import React from 'react';
import votIcon from  '../../assets/d-img.svg';
import checkIcon from '../../assets/c-img.svg';
import xpertIcon from '../../assets/x-img.svg';
import { baseUrl } from '../url';
import moment from 'moment';
import loader from '../../assets/loader.svg';
import smallLoader from '../../assets/loader-small.svg';

class TreatmentHistory extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            id: this.props.id,
            histories: [],
            page: 1,
            more: 0,
            moreResponse: true,
            response: false,
        }
        this.fetchHistories = this.fetchHistories.bind(this);
        this.loadMoreHistories =  this.loadMoreHistories.bind(this);
    }
    componentDidMount(){
        let page = this.state.page;
        this.fetchHistories(page);
    }
    
    fetchHistories(page){
        let retries = 0;
        let token = localStorage.getItem('access_token');
        let id = this.state.id;

        fetch(`${baseUrl}/admin/patients/${id}/histories?page=${page}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            if(page === 1){
                this.setState({
                    more: responseJson.meta.total - 4,
                })
            }
            for (let history in responseJson.data){
                this.setState({
                    histories: [...this.state.histories, responseJson.data[history]],
                })
            }
            this.setState({
                total: responseJson.meta.last_page,
                moreResponse: true,
                response: true,
            })
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
            else{
                alert('something went wrong please try again later');
            }
        })
    }

    loadMoreHistories(){
        if(this.state.page < this.state.total){
            let page = this.state.page + 1;
            let more = this.state.more - 4;
            this.setState({
                page: page,
                more: more,
                moreResponse: false
            },this.fetchHistories(page))
        }
    }

    render(){
        let {histories} = this.state;
;        return(
            <div className="patient-history">
                <div className="row">
                    {
                        !this.state.response &&
                        <div className="image-loader">
                            <img src={loader} alt=""/>
                        </div>
                    }
                    {
                        this.state.response &&
                        <div className="col-sm-12">
                            {
                            histories.length === 0?
                                <div className="image-loader">
                                    <h4>No history available yet.</h4>
                                </div>
                            :
                            histories.map((history, index)=>{
                                let type = history.type;
                                let dateTime = moment(history.data.treatment_time).format('MMMM D, YYYY h:mm A')
                                return(
                                    <div key={index} className={`history-card ${type}`}>
                                        {
                                            type === 'vot' &&
                                            <div className="icon-name">
                                                <img src={votIcon} alt=""/>
                                                <h4>Dosage Log</h4>
                                            </div>
                                        }
                                        {
                                            type === 'appointment' &&
                                            <div className="icon-name">
                                                <img src={checkIcon} alt=""/>
                                                <h4>Check-in with Caregiver</h4>
                                            </div>
                                        }
                                        {
                                            type === 'test' &&
                                            <div className="icon-name">
                                                <img src={xpertIcon} alt=""/>
                                                <h4>Test</h4>
                                            </div>
                                        }
                                        <p>{dateTime}</p>
                                    </div>
                                )
                            })}
                            {
                                this.state.more > 0 && this.state.moreResponse &&
                                <p className="more-text" onClick={this.loadMoreHistories}>
                                    <i className="fa fa-plus-circle"></i>Load more history ({this.state.more})
                                </p>
                            }
                            {
                                !this.state.moreResponse &&
                                <div className="image-loader">
                                    <img src={smallLoader} alt=""/>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default TreatmentHistory;


// WEBPACK FOOTER //
// ./src/components/patientProfile/TreatmentHistory.js